import React from 'react'
import { DateRange } from '../lib/types/DateRange'
import { DEFAULT_END_DATE, DEFAULT_START_DATE } from '../lib/utils/defaultDates'

interface DateRangeContextValue {
  dateRange: DateRange
  setDateRange: (dateRange: DateRange) => void
}

export const DateRangeContext = React.createContext<DateRangeContextValue>({
  dateRange: {
    dateRange: {
      startDate: DEFAULT_START_DATE,
      endDate: DEFAULT_END_DATE,
    },
  },
  setDateRange: () => {},
})

function DateRangeProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const [dateRange, setDateRange] = React.useState<DateRange>({
    dateRange: {
      startDate: DEFAULT_START_DATE,
      endDate: DEFAULT_END_DATE,
    },
  })

  return (
    <DateRangeContext.Provider value={{ dateRange, setDateRange }}>
      {children}
    </DateRangeContext.Provider>
  )
}

export default DateRangeProvider
